import type { Screen } from '~/services/layout';

/**
 * Checks if the given screen is a tabs screen
 * @param screen - The screen object to check
 * @returns true if the screen type is 'quick-brick-tabs', false otherwise
 */
export function getIsTabsScreen(screen: Screen | undefined): boolean {
  return screen?.type === 'quick-brick-tabs';
}
